export interface Chapter {
  id: string;
  title: string;
  startTime: number;
  endTime: number;
  summary: string;
  keyPoints: string[];
}

export interface VideoAnalysis {
  title: string;
  description: string;
  tools: string[];
  materials: string[];
  chapters: Chapter[];
  duration: number;
  shorts?: Short[];
  languageLearning?: LanguageLearning;
}

export interface LearningPhrase {
  id: string;
  english: string;
  korean: string;
  context: string;
  usage: string;
  startTime: number;
}

export interface LanguageLearning {
  contentTakeaways: string[];
  phrases: LearningPhrase[];
  recallPrompt: string;
}

export interface Short {
  id: string;
  title: string;
  startTime: number;
  endTime: number;
  duration: number;
  script: string;
  hookType: string;
  thumbnailUrl?: string;
}

export class GeminiService {
  async analyzeVideoFromTranscript(
    videoId: string,
    videoTitle: string,
    transcript: string,
    duration: number,
    thumbnailUrl?: string
  ): Promise<VideoAnalysis> {
    console.log('=== Gemini 분석 시작 ===');
    
    try {
      const response = await fetch('/api/analyze', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ videoId, videoTitle, transcript, duration })
      });
      if (!response.ok) throw new Error((await response.json()).error || 'AI 분석 요청에 실패했습니다.');
      const analysis = await response.json() as VideoAnalysis;

      // Inject default thumbnails and IDs
      if (analysis.shorts) {
        analysis.shorts = analysis.shorts.map((s, idx) => ({
          ...s,
          id: s.id || `short-${idx}`,
          duration: s.duration || (s.endTime - s.startTime),
          thumbnailUrl: s.thumbnailUrl || (idx === 0 && thumbnailUrl ? thumbnailUrl : `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`)
        }));
      }

      return { ...analysis, duration };

    } catch (error) {
      console.error('Gemini Analysis Error:', error);
      throw error instanceof Error ? error : new Error('AI 분석에 실패했습니다.');
    }
  }
}

export const geminiService = new GeminiService();
